import { syncUserCartForRecommendations } from 'api/cart/syncUserCardForRecommendations'
import { putUserCart } from 'api/cart/userCart'
import debounce from 'lodash.debounce'

function saveUserCart(userCartState: App.UserCartState, le_user_id?: string, domain_user_id?: string) {
  putUserCart(userCartState).catch(err => console.error(err))
  syncUserCartForRecommendations(userCartState, le_user_id, domain_user_id)
}

export const saveUserCartDebounced = debounce(saveUserCart, 300)
